import { isMobile } from '../base'

export function initCategory() {
    categoriesBannersCategory()
}

function categoriesBannersCategory() {
    $('footer .categories-banner__wrapper').appendTo($('.content-wrapper'))

    if (isMobile()) {
        $('.categories-banner__wrapper').addClass('container')
    }
}
